import React, { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import InputForm from "src/components/ComponentesFormularios/InputForm";
import ContainerSectionModal from "src/components/ContainerSectionModal";
import Tooltip from "@mui/material/Tooltip";
import TabsClassic from "src/components/TabsClassic";
import { classResponsiveForm, classResponsiveFormDoubleWidth, classResponsiveFormWidthHeader, ERRORFIELDREQUIRED } from "src/data/ConstantForm";
import { Colors } from "src/assets/colors/Colors";
import SelectForm from "src/components/ComponentesFormularios/SelectForm";
import { usuariosService } from "src/services/unoauno/apiUsuarios";
import { GlobalConstants } from "src/data/GlobalConstants";
import CustomSwitch from "src/components/Switch";

const InformacionGeneralCuenta = ({dataUsr}) => {
    return (
        <div className="w-100 row m-0 d-flex px-2" style={{gap: "7px"}}>
            <InputForm
                identificador="identificador"
                label="Identificador"
                placeholder=""
                value={dataUsr.documento}
                required={false}
                textUppercase={false}
                className={`${classResponsiveForm}`}
                disabled={true}
            />

            <InputForm
                identificador="nombresUsr"
                label="Nombres"
                placeholder=""
                value={dataUsr.nombres}
                required={false}
                textUppercase={false}
                className={`${classResponsiveFormWidthHeader}`}
                disabled={true}
            />

            <InputForm
                identificador="correoUsr"
                label="Correo"
                placeholder=""
                value={dataUsr.correo}
                required={false}
                textUppercase={false}
                className={`${classResponsiveFormWidthHeader}`}
                disabled={true}
            />

            <InputForm
                identificador="telefonoUsr"
                label="Teléfono"
                placeholder=""
                value={dataUsr.telefono}
                required={false}
                textUppercase={false}
                className={`${classResponsiveForm}`}
                disabled={true}
            />

            <InputForm
                identificador="genero"
                label="Genero"
                placeholder=""
                value={dataUsr.genero}
                required={false}
                textUppercase={false}
                className={`${classResponsiveForm}`}
                disabled={true}
            />

            <InputForm
                identificador="nacimiento"
                label="Nacimiento"
                placeholder=""
                value={dataUsr.nacimiento}
                required={false}
                textUppercase={false}
                className={`${classResponsiveForm}`}
                disabled={true}
            />

            <InputForm
                identificador="ultimaVersion"
                label="Ultima Versión"
                placeholder=""
                value={dataUsr.ultimaVersion}
                required={false}
                textUppercase={false}
                className={`${classResponsiveForm}`}
                disabled={true}
            />
        </div>
    )
}

const InformacionGeneralPuntoVenta = ({dataUsr}) => {
    return (
        <div className="w-100 row m-0 d-flex px-2" style={{gap: "7px"}}>
            <InputForm
                identificador="identificadorCliente"
                label="Identificador Cliente"
                placeholder=""
                value={dataUsr.idCliente}
                required={false}
                textUppercase={false}
                className={`${classResponsiveForm}`}
                disabled={true}
            />

            <InputForm
                identificador="identificadorNegocio"
                label="Identificador Negocio"
                placeholder=""
                value={dataUsr.idNegocio}
                required={false}
                textUppercase={false}
                className={`${classResponsiveForm}`}
                disabled={true}
            />

            <InputForm
                identificador="nombreCliente"
                label="Nombres Cliente"
                placeholder=""
                value={dataUsr.nombreCliente}
                required={false}
                textUppercase={false}
                className={`${classResponsiveFormWidthHeader}`}
                disabled={true}
            />

            <InputForm
                identificador="nombreNegocio"
                label="Nombres Negocio"
                placeholder=""
                value={dataUsr.nombreNegocio}
                required={false}
                textUppercase={false}
                className={`${classResponsiveFormWidthHeader}`}
                disabled={true}
            />

            <InputForm
                identificador="direccion"
                label="Dirección"
                placeholder=""
                value={dataUsr.direccionTx}
                required={false}
                textUppercase={false}
                className={`${classResponsiveForm}`}
                disabled={true}
            />

            <InputForm
                identificador="clasificacion"
                label="Clasificación"
                placeholder=""
                value={dataUsr.clasificacion}
                required={false}
                textUppercase={false}
                className={`${classResponsiveForm}`}
                disabled={true}
            />

            <InputForm
                identificador="canal"
                label="Canal"
                placeholder=""
                value={dataUsr.canal}
                required={false}
                textUppercase={false}
                className={`${classResponsiveForm}`}
                disabled={true}
            />

            <InputForm
                identificador="identificadorTipologia"
                label="Identificador Tipología"
                placeholder=""
                value={dataUsr.idTipologia}
                required={false}
                textUppercase={false}
                className={`${classResponsiveForm}`}
                disabled={true}
            />

            <InputForm
                identificador="nombreTipologia"
                label="Nombres Tipología"
                placeholder=""
                value={dataUsr.nombreTipologia}
                required={false}
                textUppercase={false}
                className={`${classResponsiveFormWidthHeader}`}
                disabled={true}
            />

            <InputForm
                identificador="identificadorCiudad"
                label="Identificador Ciudad"
                placeholder=""
                value={dataUsr.idCiudad}
                required={false}
                textUppercase={false}
                className={`${classResponsiveForm}`}
                disabled={true}
            />

            <InputForm
                identificador="nombreCiudad"
                label="Nombre Ciudad"
                placeholder=""
                value={dataUsr.nombreCiudad}
                required={false}
                textUppercase={false}
                className={`${classResponsiveFormWidthHeader}`}
                disabled={true}
            />

            <InputForm
                identificador="listaAsociada"
                label="Lista asociada"
                placeholder=""
                value={dataUsr.idLista}
                required={false}
                textUppercase={false}
                className={`${classResponsiveForm}`}
                disabled={true}
            />
        </div>
    )
}

const InformacionGeneral = ({dataUsr}) => {
    return (
        <div className="container mx-0 px-0 w-100 mw-100">
            <div className="w-100 px-2">
                <ContainerSectionModal label="Información de la cuenta"
                    component={
                        <InformacionGeneralCuenta dataUsr={dataUsr}/>
                    }/>
                <ContainerSectionModal label="Información del punto de venta"
                    component={
                        <InformacionGeneralPuntoVenta dataUsr={dataUsr}/>
                    }/>
            </div>
        </div>
    )
}

// const ModificarDatos = ({dataUsr, listas, puntosdeVenta}) => {
//     const dispatch = useDispatch();
//     const [puntosVenta, setPuntosVenta] = useState(puntosdeVenta)
//     const [puntosVentaDelete, setPuntosVentaDelete] = useState([])

//     const methodsPassword = useForm({defaultValues: {}});
//     const methodsLista = useForm({defaultValues: {lista: dataUsr.idLista}});

//     const { control: controlPassword, setValue: setValuePassword, handleSubmit: handleSubmitPassword, formState: { errors: errorsPassword } } = methodsPassword;
//     const { control: controlLista, handleSubmit: handleSubmitLista, formState: { errors: errorsLista } } = methodsLista;

//     const onSubmitPassword = async (data) => {
//         try {
//             await usuariosService.updatePasswordUsuario({idUsuario: dataUsr.documento, password: data.password})
//             setValuePassword('password', '');

//             dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: 'Solicitud exitosa' } });
//         } catch (error) {
//             console.log(error)
//             dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Ha ocurrido un error, comunicate con soporte' } });
//         }
//     }

//     const onSubmitLista = async (data) => {
//         try {
//             await usuariosService.updateListaUsuario({idCliente: dataUsr.idCliente, idNegocio: dataUsr.idNegocio, idLista: data.lista})

//             dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: 'Solicitud exitosa' } });
//         } catch (error) {
//             console.log(error)
//             dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Ha ocurrido un error, comunicate con soporte' } });
//         }
//     }

//     const deletePuntoVenta = (PuntoVenta) => {
//         setPuntosVentaDelete([...puntosVentaDelete, PuntoVenta])

//         let index = puntosVenta.findIndex(pt => pt.idCliente === PuntoVenta.idCliente && pt.idNegocio === PuntoVenta.idNegocio)

//         if(index != -1) {
//             puntosVenta.splice(index, 1);
//             setPuntosVenta([...puntosVenta]);
//         }
//     }

//     const changeEstadoPuntoVenta = (PuntoVenta) => {
//         let index = puntosVenta.findIndex(pt => pt.idCliente === PuntoVenta.idCliente && pt.idNegocio === PuntoVenta.idNegocio)

//         if(index != -1) {
//             puntosVenta[index].estado = !PuntoVenta.estado;
//             setPuntosVenta([...puntosVenta]);
//         }
//     }

//     const onClickSubmit = async () => {
//         try {
//             await usuariosService.updatePuntosVentaUsuario({
//                 usrDocumento: dataUsr.documento,
//                 puntosVenta: puntosVenta,
//                 puntosVentaDelete: puntosVentaDelete
//             })

//             dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: 'Solicitud exitosa' } });
//         } catch (error) {
//             console.log(error)
//             dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Ha ocurrido un error, comunicate con soporte' } });
//         }
//     }

//     return (
//         <div className="container mx-0 px-0 w-100 mw-100">
//             <FormProvider {...methodsPassword}>
//                 <div className="w-100 px-4">
//                     <strong>Modificar contraseña</strong>
//                     <div className="row m-0 mt-2 d-flex align-items-center">
//                         <InputForm
//                             inputProps={{control: controlPassword}}
//                             identificador="password"
//                             label="Contraseña"
//                             placeholder=""
//                             required={true}
//                             textUppercase={false}
//                             className={`${classResponsiveFormDoubleWidth}`}
//                             customError={errorsPassword.password ? "El campo no puede estar vacío" : null} rules={{ minLength: 0 }}
//                             style={errorsPassword.password ? { marginBottom: 0 } : ''}
//                         />

//                         <Tooltip className="ml-3" title="Guardar" aria-label="guardar">
//                             <a onClick={handleSubmitPassword(onSubmitPassword, () => {})} className="icon-container-actions d-flex">
//                                 <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
//                                 <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save fa-2x"/>
//                             </a>
//                         </Tooltip>
//                     </div>
//                 </div>
//             </FormProvider>
//             <FormProvider {...methodsLista}>
//                 <div className="w-100 px-4 mt-3">
//                     <strong>Asignar Lista de Precios</strong>
//                     <div className="row m-0 mt-2 d-flex align-items-center">
//                         <SelectForm
//                             inputProps={{control: controlLista}}
//                             identificador="lista"
//                             label="Lista de precios"
//                             options={listas}
//                             showId={false}
//                             required={true}
//                             className="px-2 col-3"
//                             customError={errorsLista.lista ? ERRORFIELDREQUIRED : null}
//                             style={errorsLista.lista ? { marginBottom: 0 } : ''}
//                         />

//                         <Tooltip className="ml-3" title="Guardar" aria-label="guardar">
//                             <a onClick={handleSubmitLista(onSubmitLista, () => {})} className="icon-container-actions d-flex">
//                                 <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
//                                 <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save fa-2x"/>
//                             </a>
//                         </Tooltip>
//                     </div>
//                 </div>
//             </FormProvider>
//             <div className="w-100">
//                 <div className="w-100 px-2 mt-3">
//                     <strong>Administrar Puntos de Venta Asignados</strong>

//                     <div className="w-100 px-3 row m-0 my-3 d-flex position-relative">
//                         <div className="col-6">
//                             {puntosVenta.length > 0 && <div className="row m-0 mb-2 py-2 w-100 d-flex align-items-center boxShadow borderRadius5">
//                                 <div className="col-3">
//                                     <p className="m-0">Id de cliente</p>
//                                 </div>
//                                 <div className="col-3">
//                                     <p className="m-0">Id de negocio</p>
//                                 </div>
//                                 <div className="col-3">
//                                     <p className="m-0">Estado</p>
//                                 </div>
//                             </div>}

//                             {puntosVenta.map((el, index) => {
//                                 return (
//                                     <div key={index} className="row m-0 mb-2 py-2 w-100 d-flex align-items-center boxShadow borderRadius5">
//                                         <div className="col-3">
//                                             <p className="m-0">{el.idCliente}</p>
//                                         </div>
//                                         <div className="col-3">
//                                             <p className="m-0">{el.idNegocio}</p>
//                                         </div>
//                                         <div className="col-3">
//                                             <CustomSwitch
//                                                 handleChange={() => changeEstadoPuntoVenta(el)}
//                                                 name="Estado"
//                                                 state={el.estado}
//                                                 key={index}
//                                             />
//                                         </div>
//                                         <div className="col-3 d-flex align-items-center">
//                                             <Tooltip title="Eliminar" aria-label="eliminar">
//                                                 <a onClick={() => deletePuntoVenta(el)} className="icon-container-actions d-flex">
//                                                     <div style={{backgroundColor: Colors.ROJO_PASTEL}}/>
//                                                     <i style={{color: Colors.ROJO_PASTEL}} className="fas fa-trash fa-2x"/>
//                                                 </a>
//                                             </Tooltip>
//                                         </div>
//                                     </div>
//                                 )
//                             })}

//                             {puntosVenta.length == 0 &&
//                                 <div className="row m-0 mb-2 mt-1 py-2 w-100 d-flex align-items-center boxShadow borderRadius5">
//                                     <div className="col-12 d-flex align-items-center">
//                                         <p className="m-0 p-0 text-center">No hay puntos de venta asignados</p>
//                                     </div>
//                                 </div>
//                             }
//                         </div>

//                         <div className="mb-2">
//                             <Tooltip className="ml-3" title="Guardar" aria-label="guardar">
//                                 <a onClick={onClickSubmit} className="icon-container-actions d-flex">
//                                     <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
//                                     <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save fa-2x"/>
//                                 </a>
//                             </Tooltip>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

const FormUsuariosCRUD = ({properties}) => {
    const { data: { dataUsr, listas, puntosdeVenta } } = properties;

    const [stateTab, setStateTab] = useState(1)

    return (
        <div className="p-2">
            <div className="d-flex align-items-center">
                <TabsClassic tabs={[
                    {
                        id: 1,
                        label: "Información general del usuario",
                        content: <InformacionGeneral dataUsr={dataUsr}/>
                    },
                    // {
                    //     id: 2,
                    //     label: "Modificar datos de usuario",
                    //     content: <ModificarDatos dataUsr={dataUsr} listas={listas} puntosdeVenta={puntosdeVenta}/>
                    // }
                ]} initialState={1} stateTab={setStateTab}/>
            </div>
        </div>
    );
}

export default FormUsuariosCRUD;
